import client from "../Client/HttpClient";
import { IPreschoolTeacherAssignmentsModel } from "@/interfaces/modules";

const ApiPath = "PreschoolTeacherAssignments";

export default {
  /** GET api/PreschoolTeacherAssignments */
  GetAll: (): Promise<IPreschoolTeacherAssignmentsModel[]> =>
    client.get(`${ApiPath}`),

  /** GET api/PreschoolTeacherAssignments/{id} */
  GetById: (id: number): Promise<IPreschoolTeacherAssignmentsModel> =>
    client.get(`${ApiPath}/${id}`),

  /** GET api/PreschoolTeacherAssignments/byTeacher/{teacherId} */
  GetByTeacherId: (teacherId: number): Promise<IPreschoolTeacherAssignmentsModel[]> =>
    client.get(`${ApiPath}/byTeacher/${teacherId}`),

  /** GET api/PreschoolTeacherAssignments/byGroup/{groupId} */
  GetByGroupId: (groupId: number): Promise<IPreschoolTeacherAssignmentsModel[]> =>
    client.get(`${ApiPath}/byGroup/${groupId}`),

  /** GET api/PreschoolTeacherAssignments/byYear/{academicYearId} */
  GetByAcademicYearId: (academicYearId: number): Promise<IPreschoolTeacherAssignmentsModel[]> =>
    client.get(`${ApiPath}/byYear/${academicYearId}`),

  /** POST api/PreschoolTeacherAssignments */
  Post: (data: IPreschoolTeacherAssignmentsModel): Promise<IPreschoolTeacherAssignmentsModel> =>
    client.post(`${ApiPath}`, data),
};
